import { render, staticRenderFns } from "./ProductButton.vue?vue&type=template&id=2900b838"
import script from "./ProductButton.vue?vue&type=script&lang=js"
export * from "./ProductButton.vue?vue&type=script&lang=js"
import style0 from "./ProductButton.vue?vue&type=style&index=0&id=2900b838&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports